import { Col, Form, FormProps, Row } from 'react-bootstrap';
import DatePickerInput from '../../../../components/DatePicker';
import NumberInput from '../../../../components/NumberInput/NumberInput';

export type customEstimateFormProps = FormProps &
  React.PropsWithoutRef<{
    collectData: (formData: any) => void;
    data: any;
  }>;

export type PensionData = {
  whenToStopWorking: Date;
  whenToStartPension: Date;
  beneficiaryBirthDate: Date;
  percent: number;
};

const NewEstimateForm = ({ collectData, data }: customEstimateFormProps) => {
  const handleOnNumberChange = (e: any) => {
    collectData({ ...data, percent: e });
  };

  const handleStopWorkingDateChange = (e: any) => {
    collectData({ ...data, whenToStopWorking: e });
  };

  const handleStartPensionDateChange = (e: any) => {
    collectData({ ...data, whenToStartPension: e });
  };

  const handleBeneficiaryBirthDateChange = (e: any) => {
    collectData({ ...data, beneficiaryBirthDate: e });
  };

  return (
    <Form>
      <Row className="d-flex justify-content-between">
        <Col>
          <Form.Label className="text-fs-6 mt-10">
            When do you want to stop working?
          </Form.Label>
          <DatePickerInput
            placeholder={'Select a date'}
            className="me-4"
            minDate={new Date()}
            initialDate={data.whenToStopWorking || undefined}
            onChange={handleStopWorkingDateChange}
          />
          <Col>
            <Form.Label className="text-fs-6 mt-10">
              When do you want to begin receiving pension benefits?
            </Form.Label>
            <DatePickerInput
              placeholder={'Select a date'}
              className="me-4"
              minDate={new Date()}
              initialDate={data.whenToStartPension || undefined}
              onChange={handleStartPensionDateChange}
            />
          </Col>
          <Col>
            <Form.Label className="text-fs-6 mt-10">
              What is your Beneficiary’s birth date?
            </Form.Label>
            <DatePickerInput
              placeholder={'Select a date'}
              className="me-4"
              maxDate={new Date()}
              initialDate={data.beneficiaryBirthDate || undefined}
              onChange={handleBeneficiaryBirthDateChange}
            />
          </Col>
          <Col>
            <Form.Label className="text-fs-6 mt-10">
              What future pay increase percentage do you expect?
            </Form.Label>
            <NumberInput
              placeholder={'0'}
              className="me-4"
              label={''}
              value={data.percent || 0}
              minValue={'0'}
              isPercent
              maxValue={'100'}
              onChange={handleOnNumberChange}
            />
          </Col>
        </Col>
      </Row>
    </Form>
  );
};

export default NewEstimateForm;
